<main>
  <div class="container">

    <div class="row mb-4">
      <div class="col general-title">
        <h2>Recebimentos</h2>
      </div>
    </div>

    <div class="filters pt-2 pt-lg-4 pl-2 pl-lg-4 pb-3 pb-lg-5">
      <div class="row w-100" [formGroup]="formFiltro">

        <div class="col-auto mr-3 mb-2 mb-lg-0">
          <label for="data_inicio">Status</label>
          <select name="ordernar" id="ordernar" formControlName="codStatus" (change)="listar()" [disabled]="loading">
            <option selected disabled value="0">Status</option>
            <option value="">Todos</option>
            @for (dtIni of listStatusCob; track dtIni) {
              <option  value="{{dtIni.DCR_COB_STATUS_EXT}}">{{dtIni.DCR_COB_STATUS_EXT}}</option>
            }
          </select>
        </div>
        <div class="col-auto mr-3 mb-2 mb-lg-0">
          <label for="data_inicio">De</label>
          <select name="data_inicio"  formControlName="anomesInicio" [disabled]="loading">
            <option disabled selected value="0">Data início</option>
            @for (dtIni of listPrimeiroAnoMes; track dtIni) {
              <option  value="{{dtIni.ANOMES}}">{{dtIni.ANOMES_FORMATADO}}</option>
            }
          </select>
        </div>
        <div class="col-auto mr-3 mb-2 mb-lg-0">
          <label for="data_fim">Até</label>
          <select name="data_fim" formControlName="anomesFim" [disabled]="loading" (change)="listar()">
            <option disabled selected value="0">Data fim</option>
            @for (dtFim of listUltimoAnoMes; track dtFim) {
              <option value="{{dtFim.ANOMES}}">{{dtFim.ANOMES_FORMATADO}}</option>
            }
          </select>
        </div>
        <div class="col-auto mr-auto mb-2 mb-lg-0">
          <select name="ordernar" id="ordernar" formControlName="tipoOrdem" [disabled]="loading">
            <option selected disabled value="0">Ordenar por</option>
            <option value="1">Data</option>
            <option value="2">Valor</option>
          </select>
        </div>
        <div class="col-auto divbtnFiltro">
          <button class="btn btn-success" (click)="listar()" [disabled]="loading"><i class="fa fa-filter"></i> Filtrar</button>
        </div>
        <div class="col-auto divbtnExportar">
          <button class="btn btn-extract" (click)="print()" [disabled]="loading"><i class="fa fa-print"></i> Emitir Extrato</button>
        </div>

      </div>
    </div>

    <div class="box table-responsive mb-4">
      <table class="table table-borderless table-hover">
        <thead>
          <tr>
            <th class="text-center boletos">Boleto</th>
            <th class="text-center">Cod. Cobrança</th>
            <th class="">Status</th>
            <th class="text-center">Valor</th>
            <th class="text-center">Vencimento</th>
            <th class="text-center">Forma de Cobrança</th>
            <th class="text-center">Valor Pago</th>
            <th class="text-center">Data Pagamento</th>

          </tr>
        </thead>
        <tbody>
          @for (item of movimentacoes | paginate: { itemsPerPage: qntPorPage, currentPage: paginaAtual }; track item) {
            <tr>
              <td class="text-center boletos buttons">
                @if (item.BLT_DEC_IMPRESSAO==1 || item.BLT_DEC_DCR_LIN_DIG==1) {
                  <button title="Gerar Boleto" type="button" class="btn btn-light" [disabled]="item.loadingBoleto" (click)="itemSelecionado = item; buscarDadosBoleto(item)" style="padding: 0.375rem 0.75rem;">
                    @if (!item.loadingBoleto) {
                      <span><i class="fas fa-print"></i></span>
                    }
                    @if (item.loadingBoleto) {
                      <span><i class="fas fa-spinner fa-spin"></i></span>
                    }
                  </button>
                }
              </td>
              <td class="text-center">{{item.COD_COBRANCA}}</td>
              <td class="{{item.CLASSE}}"><i class="fas fa-circle"></i>{{item.DCR_COB_STATUS_EXT}}</td>
              <td class="text-center">{{item.VLR_VENC | currency:'R$'}}</td>
              <td class="text-center">{{item.DTA_VENC| date:'dd/MM/yyyy'}}</td>
              <td class="text-center">{{item.DCR_FORMA_PGTO}}</td>
              <td class="text-center">{{item.VLR_PGTO| currency:'R$'}}</td>
              <td class="text-center">{{item.DTA_PGTO| date:'dd/MM/yyyy'}}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="col-md-12  text-right">
      <pagination-controls (pageChange)="paginaAtual = $event" previousLabel="Anterior" nextLabel="Próximo"></pagination-controls>
    </div>

  </div>


  <!-- Modal -->
  <div class="modal fade" id="modalBoleto" tabindex="-1" role="dialog" aria-labelledby="modalBoletoLabel" aria-hidden="true" #container>
    <div class="modal-dialog modal-sm" role="document" style="max-width: 700px;">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalBoletoLabel">Boleto</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="padding: 1rem;">

          <div class="p-1">
            Valor: <strong>{{dadosBoleto?.VLR_TITULO| currency:'R$'}}</strong><br>
            Vencimento: <strong>{{dadosBoleto?.DTA_VENCIMENTO| date:'dd/MM/yyyy'}}</strong><br>
          </div>

          <div class="mt-1 p-1">
            Código para pagamento:
          </div>
          <div class="codigo-boleto p-2 text-center" style="font-size: 18px; font-weight: bold;">
            {{dadosBoleto?.DCR_LIN_DIG}}
          </div>

          <div class="text-center">
            <button class="btn btn-primary mr-2 mt-2" (click)="copyToClipboardAndToast(dadosBoleto?.DCR_LIN_DIG, 'Código copiado')" style="padding: 0.375rem 0.75rem;">
              <i class="far fa-copy"></i>
              COPIAR CÓDIGO
            </button>

            <button class="btn btn-primary ml-2 mt-2" [disabled]="loadingGerarBoleto" (click)="gerarPDFBoleto()" style="padding: 0.375rem 0.75rem;">
              @if (!loadingGerarBoleto) {
                <span><i class="far fa-file-pdf"></i></span>
              }
              @if (loadingGerarBoleto) {
                <span><i class="fas fa-spinner fa-spin"></i></span>
              }
              GERAR PDF
            </button>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
        </div>
      </div>
    </div>
  </div>

</main>